import axios from "axios";

const BASE_URL = "/api/insurance/insuredVehicles";

export function getCoverageTypes(vehicleType) {
  return axios.get(`${BASE_URL}/coverageTypes?vehicleType=${vehicleType}`, {});
}

export function getInsuredVehicle(insuredVehicleId) {
  return axios.get(`${BASE_URL}`, {
    params: { insuredVehicleId: insuredVehicleId }
  });
}

export function newCoverageChangeRequest(
  insuredVehicleId,
  coverageCodes,
  startDate
) {
  let body = {
    insuredVehicleId: insuredVehicleId,
    coverageCodes: coverageCodes,
    startDate: startDate
  };

  return axios.post(`${BASE_URL}/coverageChangeRequest`, body);
}
